let defaultClient = {
    fio: '',
    email: '',
    description: '',
    income_source_id: null,
    income_source: '',
    is_agency: false,
    agency: '',
    user_id: null,
    //TODO поки не треба
    social: null,
    user: null,
    phoneNumbers: [{
        phoneNumber: ''
    }],
};

export default defaultClient;

